// @flow
export const VALIDATION_ERROR_CARD_INVALID = 'Please check your payment information.';
export const VALIDATION_ERROR_DATE_INVALID = 'date must be MM/DD/YYYY';
export const VALIDATION_ERROR_EMAIL_REGISTERED = 'email address already registered';
export const VALIDATION_ERROR_EMAIL_VALID = 'please provide a valid email';
export const VALIDATION_ERROR_PASSWORD_MIN_CHARS = '8 characters required';
export const VALIDATION_ERROR_PASSWORD_NOT_MATCH = 'Passwords must match';
export const VALIDATION_ERROR_PASSWORD_MIN_CHARS_NEW = '(8 Characters, 1 Letter, 1 Number)';
export const VALIDATION_ERROR_PHONE_VALID = 'please enter a valid phone number';
export const VALIDATION_ERROR_REQUIRED = 'required';
export const VALIDATION_ERROR_ZIPCODE_VALID = 'please provide a valid zip code';
